"use client";

import { c as _c } from "react/compiler-runtime";
import { AuthContext } from "@/components/auth/Auth";
import { ReactQueryWrapperContext } from "@/components/react-query-wrapper/ReactQueryWrapper";
import UserSettingsSave from "@/components/user/settings/UserSettingsSave";
import UserSettingsUsername from "@/components/user/settings/UserSettingsUsername";
import { ApiCreateOrUpdateProfileRequest } from "@/entities/IProfile";
import { ApiIdentity } from "@/generated/models/ApiIdentity";
import { commonApiPost } from "@/services/api/common-api";
import { useMutation } from "@tanstack/react-query";
import { useParams, usePathname, useRouter } from "next/navigation";
import { useContext, useEffect, useRef, useState } from "react";
import { createPortal } from "react-dom";
import { useClickAway, useKeyPressEvent } from "react-use";
export default function UserPageHeaderEditName(t0) {
  const $ = _c(45);
  const {
    profile,
    onClose
  } = t0;
  const modalRef = useRef(null);
  useClickAway(modalRef, onClose);
  useKeyPressEvent("Escape", onClose);
  const {
    setToast,
    requestAuth
  } = useContext(AuthContext);
  const {
    onProfileEdit
  } = useContext(ReactQueryWrapperContext);
  const router = useRouter();
  const pathname = usePathname() ?? "";
  const params = useParams();
  const [userName, setUserName] = useState(profile.handle ?? "");
  const [haveChanges, setHaveChanges] = useState(false);
  let t1;
  if ($[0] !== profile.handle || $[1] !== userName) {
    t1 = () => {
      setHaveChanges(userName !== profile.handle);
    };
    $[0] = profile.handle;
    $[1] = userName;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== userName) {
    t2 = [userName];
    $[3] = userName;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  useEffect(t1, t2);
  const [mutating, setMutating] = useState(false);
  let t3;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = async body => {
      setMutating(true);
      return await commonApiPost({
        endpoint: "profiles",
        body
      });
    };
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== onClose || $[7] !== onProfileEdit || $[8] !== params?.user || $[9] !== pathname || $[10] !== profile || $[11] !== router || $[12] !== setToast) {
    t4 = async updatedProfile => {
      setToast({
        message: "Profile updated.",
        type: "success"
      });
      const newPath = pathname.replace(params?.user?.toString() ?? "", updatedProfile.handle?.toLowerCase());
      await router.replace(newPath);
      onProfileEdit({
        profile: updatedProfile,
        previousProfile: profile
      });
      onClose();
    };
    $[6] = onClose;
    $[7] = onProfileEdit;
    $[8] = params?.user;
    $[9] = pathname;
    $[10] = profile;
    $[11] = router;
    $[12] = setToast;
    $[13] = t4;
  } else {
    t4 = $[13];
  }
  let t5;
  if ($[14] !== setToast) {
    t5 = error => {
      setToast({
        message: error as string,
        type: "error"
      });
    };
    $[14] = setToast;
    $[15] = t5;
  } else {
    t5 = $[15];
  }
  let t6;
  if ($[16] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = () => {
      setMutating(false);
    };
    $[16] = t6;
  } else {
    t6 = $[16];
  }
  let t7;
  if ($[17] !== t4 || $[18] !== t5) {
    t7 = {
      mutationFn: t3,
      onSuccess: t4,
      onError: t5,
      onSettled: t6
    };
    $[17] = t4;
    $[18] = t5;
    $[19] = t7;
  } else {
    t7 = $[19];
  }
  const updateUser = useMutation(t7);
  let t8;
  if ($[20] !== profile.banner1 || $[21] !== profile.banner2 || $[22] !== profile.classification || $[23] !== profile.pfp || $[24] !== profile.primary_wallet || $[25] !== requestAuth || $[26] !== setToast || $[27] !== updateUser || $[28] !== userName) {
    t8 = async e => {
      e.preventDefault();
      if (!profile.primary_wallet || !profile.classification) {
        return;
      }
      const {
        success
      } = await requestAuth();
      if (!success) {
        setToast({
          message: "You must be logged in to save settings",
          type: "error"
        });
        return;
      }
      const body_0 = {
        handle: userName,
        classification: profile.classification,
        pfp_url: profile.pfp ?? undefined
      };
      if (profile.banner1) {
        body_0.banner_1 = profile.banner1;
      }
      if (profile.banner2) {
        body_0.banner_2 = profile.banner2;
      }
      if (profile.pfp) {
        body_0.pfp_url = profile.pfp;
      }
      await updateUser.mutateAsync(body_0);
    };
    $[20] = profile.banner1;
    $[21] = profile.banner2;
    $[22] = profile.classification;
    $[23] = profile.pfp;
    $[24] = profile.primary_wallet;
    $[25] = requestAuth;
    $[26] = setToast;
    $[27] = updateUser;
    $[28] = userName;
    $[29] = t8;
  } else {
    t8 = $[29];
  }
  const onSubmit = t8;
  const [available, setAvailable] = useState(false);
  const [checkingUsername, setCheckingUsername] = useState(false);
  if (typeof document === "undefined") {
    return null;
  }
  let t9;
  if ($[30] !== onClose) {
    t9 = <button type="button" aria-label="Close edit username modal" className="tw-absolute tw-inset-0 tw-bg-gray-600 tw-bg-opacity-50 tw-backdrop-blur-[1px] tw-cursor-pointer tw-border-none tw-p-0" onClick={onClose} />;
    $[30] = onClose;
    $[31] = t9;
  } else {
    t9 = $[31];
  }
  const t10 = profile.handle ?? "";
  let t11;
  if ($[32] !== t10 || $[33] !== userName) {
    t11 = <UserSettingsUsername userName={userName} originalUsername={t10} setUserName={setUserName} setIsAvailable={setAvailable} setIsLoading={setCheckingUsername} />;
    $[32] = t10;
    $[33] = userName;
    $[34] = t11;
  } else {
    t11 = $[34];
  }
  const t12 = !haveChanges || !available || checkingUsername;
  let t13;
  if ($[35] !== mutating || $[36] !== t12) {
    t13 = <UserSettingsSave loading={mutating} disabled={t12} />;
    $[35] = mutating;
    $[36] = t12;
    $[37] = t13;
  } else {
    t13 = $[37];
  }
  let t14;
  if ($[38] !== onSubmit || $[39] !== t11 || $[40] !== t13) {
    t14 = <div className="tw-relative tw-flex tw-min-h-full tw-w-full tw-overflow-y-auto tw-items-center tw-justify-center tw-p-2 lg:tw-p-4"><div ref={modalRef} className="tw-w-full tw-transform tw-rounded-xl tw-bg-iron-950 tw-text-left tw-shadow-xl tw-transition-all tw-duration-500 tw-p-6 lg:tw-p-8 md:tw-max-w-xl"><form onSubmit={onSubmit} className="tw-flex tw-flex-col">{t11}{t13}</form></div></div>;
    $[38] = onSubmit;
    $[39] = t11;
    $[40] = t13;
    $[41] = t14;
  } else {
    t14 = $[41];
  }
  let t15;
  if ($[42] !== t14 || $[43] !== t9) {
    t15 = createPortal(<div className="tailwind-scope tw-fixed tw-inset-0 tw-z-[1100] tw-cursor-default">{t9}{t14}</div>, document.body);
    $[42] = t14;
    $[43] = t9;
    $[44] = t15;
  } else {
    t15 = $[44];
  }
  return t15;
}